<template>
  <!-- 基本信息 -->
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-width="160px"
    :inline="true"
    :disabled="true"
  >
    <div class="form_container">
      <!-- 国家/地区 -->
      <el-form-item label="国家/地区" prop="countryName">
        <el-select
          v-model="form.countryName"
          filterable
          clearable
          placeholder="请选择"
          :disabled="true"
        >
          <el-option
            v-for="(item, index) in countryList.filter(item => {
              return item.areaName == form.areaName;
            })"
            :key="index"
            :label="item.countryName"
            :value="item.countryName"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 所属大区 -->
      <el-form-item label="所属大区" prop="areaName">
        <el-select
          v-model="form.areaName"
          filterable
          clearable
          placeholder="请选择"
          @change="changeArea"
          :disabled="true"
        >
          <el-option
            v-for="(item, index) in areaList"
            :key="index"
            :label="item.areaName"
            :value="item.areaName"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 所属大洲 -->
      <el-form-item label="所属大洲" prop="belonging">
        <el-input v-model="form.belonging" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- 销售经理 -->
      <el-form-item label="销售经理" prop="saleManager">
        <el-input v-model="form.saleManager" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- 面积(万平方公里) -->
      <el-form-item label="面积" prop="area">
        <div class="input_number_box">
          <el-input-number
            class="number_input"
            :controls="false"
            :precision="2"
            v-model="form.area"
            style="width:99px"
          >
          </el-input-number>
          <div class="number_input_append">万平方公里</div>
        </div>
      </el-form-item>
      <!-- 出口状态 -->
      <el-form-item label="出口状态" prop="exitStatus">
        <el-select v-model="form.exitStatus" filterable clearable placeholder="请选择">
          <el-option label="CBU" value="CBU" />
          <el-option label="SKD" value="SKD" />
          <el-option label="CKD" value="CKD" />
        </el-select>
      </el-form-item>
      <!-- 人口(2024年) -->
      <el-form-item label="人口(2024年)" prop="population">
        <div class="input_number_box">
          <el-input-number
            class="number_input"
            :controls="false"
            :precision="2"
            v-model="form.population"
            style="width:141px"
          >
          </el-input-number>
          <div class="number_input_append">万人</div>
        </div>
      </el-form-item>
      <!-- 市场状态 -->
      <el-form-item label="市场状态" prop="marketStatus">
        <el-input v-model="form.marketStatus" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- 首都 -->
      <el-form-item label="首都" prop="capital">
        <el-input v-model="form.capital" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- 人均GDP(2023年) -->
      <el-form-item label="人均GDP(2023年)" prop="gdp">
        <div class="input_number_box">
          <el-input-number
            class="number_input"
            :controls="false"
            :precision="2"
            v-model="form.gdp"
            style="width:141px"
          >
          </el-input-number>
          <div class="number_input_append">美元</div>
        </div>
      </el-form-item>
      <!-- 行政区数量 -->
      <el-form-item label="行政区数量" prop="regionNumber">
        <el-input v-model="form.regionNumber" placeholder="请输入"> </el-input>
      </el-form-item>
      <!-- 官方语言 -->
      <el-form-item label="官方语言" prop="language">
        <el-input v-model="form.language" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- 汽车行业销售淡旺季 -->
      <el-form-item label="汽车行业销售淡旺季" prop="season">
        <el-input v-model="form.season" placeholder="请输入" />
      </el-form-item>
      <!-- 四季气候分类 -->
      <el-form-item label="四季气候分类" prop="climaticClassification">
        <el-input v-model="form.climaticClassification" placeholder="请输入" />
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import {
  getAreaCountryListApi,
  addOrUpdateBaseInfoApi
} from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      // 区域
      areaList: [],
      // 国家
      countryList: [],
      form: this.getForm(),
      rules: {
        countryName: [
          { required: true, message: "国家/地区不能为空", trigger: "change" }
        ],
        areaName: [
          { required: true, message: "所属大区不能为空", trigger: "change" }
        ],
        belonging: [
          { required: true, message: "所属大洲不能为空", trigger: "blur" }
        ],
        saleManager: [
          { required: true, message: "销售经理不能为空", trigger: "blur" }
        ],
        area: [{ required: true, message: "面积不能为空", trigger: "blur" }],
        exitStatus: [
          { required: true, message: "出口状态不能为空", trigger: "change" }
        ],
        population: [
          { required: true, message: "人口(2024年)不能为空", trigger: "blur" }
        ],
        marketStatus: [
          { required: true, message: "市场状态不能为空", trigger: "blur" }
        ],
        capital: [{ required: true, message: "首都不能为空", trigger: "blur" }],
        gdp: [
          {
            required: true,
            message: "人均GDP(2023年)不能为空",
            trigger: "blur"
          }
        ],
        regionNumber: [
          { required: true, message: "行政区数量不能为空", trigger: "blur" }
        ],
        language: [
          { required: true, message: "官方语言不能为空", trigger: "blur" }
        ],
        season: [
          {
            required: true,
            message: "汽车行业销售淡旺季不能为空",
            trigger: "blur"
          }
        ],
        climaticClassification: [
          { required: true, message: "四季气候分类不能为空", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    async init(data) {
      // 获取区域国家
      this.getAreaCountryList();
      this.form = this.getForm(data || {});
    },
    // 获取地区国家列表
    async getAreaCountryList() {
      const res = await getAreaCountryListApi();
      this.areaList = res.data.saleAreaList || [];
      this.countryList = res.data.saleCountryList || [];
    },
    // 获取表单数据
    getForm(data = {}) {
      return {
        id: data.id || "",
        countryName: data.countryName || "",
        areaName: data.areaName || "",
        belonging: data.belonging || "",
        saleManager: data.saleManager || "",
        area: data.area ?? undefined,
        exitStatus: data.exitStatus || "",
        population: data.population ?? undefined,
        marketStatus: data.marketStatus || "",
        capital: data.capital || "",
        gdp: data.gdp ?? undefined,
        regionNumber: data.regionNumber || "",
        language: data.language || "",
        season: data.season || "",
        climaticClassification: data.climaticClassification || ""
      };
    },
    // 区域改变
    changeArea() {
      this.form.countryName = "";
    },
    // 保存
    async handleSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        try {
          const submitData = JSON.parse(JSON.stringify(this.form));
          const res = await addOrUpdateBaseInfoApi(submitData);
          if (res.status == 0) {
            this.$DonMessage.success("操作成功！");
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form_container {
  margin-top: 34px;
  ::v-deep {
    .el-input {
      width: 200px;
    }
  }
  .input_number_box {
    width: 200px;
  }
  .number_input {
    ::v-deep {
      .el-input__inner {
        text-align: left;
        border-radius: 4px 0 0 4px;
      }
      .el-input {
        width: 100%;
      }
    }
  }
  .number_input_append {
    color: #666666;
    background: #efefef;
    border-radius: 0 4px 4px 0;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    text-align: center;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    border: 1px solid #dcdfe6;
    border-left: none;
    box-sizing: border-box;
  }
}
</style>
